module.exports = __webpack_public_path__ + "img/5.99846fd9.jpg";